interface AdminHeaderProps {
  email: string | null;
  onLogout: () => void;
  onRefresh: () => void;
  refreshing: boolean;
}

export default function AdminHeader({ email, onLogout, onRefresh, refreshing }: AdminHeaderProps) {
  return (
    <header className="sticky top-0 z-40 bg-background-50/95 backdrop-blur-md border-b border-secondary-200/70">
      <div className="max-w-5xl mx-auto px-4 md:px-6 h-14 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2.5 min-w-0">
          <span className="w-8 h-8 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center shrink-0">
            <i className="ri-heart-pulse-line text-base"></i>
          </span>
          <div className="min-w-0">
            <p className="text-sm font-semibold text-foreground-900 leading-tight truncate">郡主后台</p>
            <p className="text-[11px] text-foreground-400 leading-tight truncate">
              {email || '管理员'}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2 shrink-0">
          <button
            type="button"
            onClick={onRefresh}
            disabled={refreshing}
            title="刷新数据"
            className="w-9 h-9 flex items-center justify-center rounded-lg border border-secondary-200 bg-background-50 text-foreground-600 hover:text-primary-600 hover:border-primary-300 disabled:opacity-50 transition-colors cursor-pointer"
          >
            <i className={`ri-refresh-line text-base ${refreshing ? 'animate-spin' : ''}`}></i>
          </button>
          <button
            type="button"
            onClick={onLogout}
            className="h-9 px-3 rounded-lg border border-secondary-200 bg-background-50 text-sm text-foreground-600 hover:text-primary-600 hover:border-primary-300 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5"
          >
            <i className="ri-logout-box-r-line"></i>
            <span className="hidden sm:inline">退出</span>
          </button>
        </div>
      </div>
    </header>
  );
}